module.exports = __webpack_public_path__ + "static/media/rca.11771b5c.svg";